(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CloturationContratDialogController', CloturationContratDialogController);

    CloturationContratDialogController.$inject = [
        '$scope', '$q', '$uibModalInstance', 'entity', 'Contrat', 'ClosingContractReason',
        'LigneContrat', 'Billing', 'ReleveCompteur', 'ImpactPenalitRemiseRegul'
    ];

    function CloturationContratDialogController(
        $scope, $q, $uibModalInstance, entity, Contrat, ClosingContractReason,
        LigneContrat, Billing, ReleveCompteur, ImpactPenalitRemiseRegul
    ) {
        var vm = this;

        vm.idContrat = entity.id;
        vm.step = 'input';
        vm.isPreparing = false;
        vm.isSaving = false;
        vm.functionalError = null;
        vm.closingContractReasons = ClosingContractReason.query({ offset: 0, size: 1000});
        vm.selectedClosingContractReason = null;
        vm.contrat = null;
        vm.activeLines = [];
        vm.autoResolution = {
            apply: false,
            label: null,
            commentaire: null
        };
        vm.review = emptyReview();
        vm.readingIndividualMeter = {
            releveCompteur: {id: -1},
            readingDate: new Date()
        };

        vm.nextStep = nextStep;
        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.canFinalize = canFinalize;
        vm.getPrimaryActionLabel = getPrimaryActionLabel;

        vm.datePickerOpenStatus = {
            readingDate: false
        };

        loadContractAndLines();

        function emptyReview() {
            return {
                lineStates: [],
                transfers: [],
                debtWaivers: [],
                windfallGains: [],
                totalBalance: 0,
                hasOutstandingBalances: false
            };
        }

        function loadContractAndLines() {
            return $q.all({
                contrat: Contrat.get({id: vm.idContrat}).$promise,
                lignes: LigneContrat.findActifByContrat({idContrat: vm.idContrat}).$promise
            }).then(function(result) {
                vm.contrat = result.contrat;
                vm.activeLines = result.lignes || [];
                initialiseReadingModel();
                return result;
            });
        }

        function initialiseReadingModel() {
            if (!vm.contrat || !vm.contrat.individualMeter) {
                return;
            }
            vm.readingIndividualMeter.individualMeter = vm.contrat.individualMeter;
            vm.readingIndividualMeter.datePrecedentReleveCompteur = vm.contrat.individualMeter.datePrecedenteLecture;
            vm.readingIndividualMeter.valeurPrecedentReleve = vm.contrat.individualMeter.valeurPrecedenteLecture;
            if (!vm.readingIndividualMeter.readingDate) {
                vm.readingIndividualMeter.readingDate = new Date();
            }
        }

        function nextStep() {
            vm.functionalError = null;
            if (vm.step === 'input') {
                prepareClosingReview();
                return;
            }
            finalizeClosing();
        }

        function prepareClosingReview() {
            vm.isPreparing = true;
            runPreparationFlow()
                .then(loadContractAndLines)
                .then(function(result) {
                    vm.review = buildReview(result.lignes || []);
                    vm.autoResolution.apply = vm.review.transfers.length > 0
                        || vm.review.debtWaivers.length > 0
                        || vm.review.windfallGains.length > 0;
                    vm.step = 'review';
                })
                .catch(handleFailure)
                .finally(function() {
                    vm.isPreparing = false;
                });
        }

        function runPreparationFlow() {
            return saveFinalMeterReadingIfNeeded()
                .then(function() {
                    return loadActiveLines();
                })
                .then(function(lines) {
                    return establishBilling(lines);
                });
        }

        function saveFinalMeterReadingIfNeeded() {
            if (!vm.contrat || !vm.contrat.individualMeter) {
                return $q.when();
            }
            vm.readingIndividualMeter.datePrecedentReleveCompteur = vm.contrat.individualMeter.datePrecedenteLecture;
            vm.readingIndividualMeter.valeurPrecedentReleve = vm.contrat.individualMeter.valeurPrecedenteLecture;
            vm.readingIndividualMeter.individualMeter = vm.contrat.individualMeter;
            return ReleveCompteur.addReading(vm.readingIndividualMeter).$promise;
        }

        function loadActiveLines() {
            return LigneContrat.findActifByContrat({idContrat: vm.idContrat}).$promise;
        }

        function establishBilling(lines) {
            var outstandingCreditLine = findOutstandingCreditLine(lines);
            if (outstandingCreditLine) {
                // POST without business payload: keep an explicit empty body so Angular preserves the path param.
                return Billing.billOutstandingCredit({idLigneContrat: outstandingCreditLine.id}, {}).$promise;
            }
            return Billing.createForContract({contractId: vm.idContrat}).$promise;
        }

        function findOutstandingCreditLine(lines) {
            var foundLine = null;
            angular.forEach(lines || [], function(line) {
                if (!foundLine
                        && !line.closed
                        && line.serviceVendu
                        && line.serviceVendu.typePaiement === 'A_PAYER_AVEC_ECHELONNEMENT') {
                    foundLine = line;
                }
            });
            return foundLine;
        }

        function buildReview(lines) {
            var review = emptyReview();
            var workingStates = [];

            angular.forEach(lines || [], function(line) {
                var currentBalance = roundAmount(calculateLineBalance(line));
                var lineState = {
                    line: line,
                    currentBalance: currentBalance,
                    remainingBalance: currentBalance,
                    transferIn: 0,
                    transferOut: 0,
                    proposedAdjustmentType: null,
                    proposedAdjustmentAmount: 0
                };
                workingStates.push(lineState);
                review.totalBalance = roundAmount(review.totalBalance + currentBalance);
            });

            applyTransferSuggestions(workingStates, review.transfers);

            angular.forEach(workingStates, function(state) {
                if (state.remainingBalance < -0.009) {
                    state.proposedAdjustmentType = 'DEBT_WAIVER';
                    state.proposedAdjustmentAmount = roundAmount(-state.remainingBalance);
                    review.debtWaivers.push({
                        line: state.line,
                        amount: state.proposedAdjustmentAmount
                    });
                } else if (state.remainingBalance > 0.009) {
                    state.proposedAdjustmentType = 'WINDFALL_GAIN';
                    state.proposedAdjustmentAmount = roundAmount(state.remainingBalance);
                    review.windfallGains.push({
                        line: state.line,
                        amount: state.proposedAdjustmentAmount
                    });
                }
            });

            review.lineStates = workingStates;
            review.hasOutstandingBalances = review.transfers.length > 0
                || review.debtWaivers.length > 0
                || review.windfallGains.length > 0;
            return review;
        }

        function applyTransferSuggestions(lineStates, transfers) {
            var positiveStates = lineStates.filter(function(state) {
                return state.remainingBalance > 0.009;
            });
            var negativeStates = lineStates.filter(function(state) {
                return state.remainingBalance < -0.009;
            });

            var positiveIndex = 0;
            var negativeIndex = 0;

            while (positiveIndex < positiveStates.length && negativeIndex < negativeStates.length) {
                var positiveState = positiveStates[positiveIndex];
                var negativeState = negativeStates[negativeIndex];
                var transferAmount = roundAmount(Math.min(positiveState.remainingBalance, -negativeState.remainingBalance));

                if (transferAmount <= 0) {
                    break;
                }

                transfers.push({
                    sourceLine: positiveState.line,
                    targetLine: negativeState.line,
                    amount: transferAmount
                });

                positiveState.transferOut = roundAmount(positiveState.transferOut + transferAmount);
                negativeState.transferIn = roundAmount(negativeState.transferIn + transferAmount);
                positiveState.remainingBalance = roundAmount(positiveState.remainingBalance - transferAmount);
                negativeState.remainingBalance = roundAmount(negativeState.remainingBalance + transferAmount);

                if (positiveState.remainingBalance <= 0.009) {
                    positiveIndex += 1;
                }
                if (negativeState.remainingBalance >= -0.009) {
                    negativeIndex += 1;
                }
            }
        }

        function calculateLineBalance(line) {
            if (!line) {
                return 0;
            }
            if (line.moneyboxApresPaiement !== null && line.moneyboxApresPaiement !== undefined) {
                return line.moneyboxApresPaiement;
            }
            if (line.serviceVendu
                    && line.serviceVendu.typePaiement === 'A_PAYER_AVEC_ECHELONNEMENT'
                    && line.derniereLignePaiement) {
                return roundAmount((line.derniereLignePaiement.montantTotalDejaPaye || 0)
                    - (line.derniereLignePaiement.montantTotalAPayer || 0));
            }
            return 0;
        }

        function finalizeClosing() {
            vm.isSaving = true;
            vm.functionalError = null;

            $q.when()
                .then(function() {
                    if (!vm.autoResolution.apply && vm.review.hasOutstandingBalances) {
                        throw new Error('Le contrat n\'est pas encore régularisé. Activez les ajustements automatiques ou régularisez manuellement avant de clôturer.');
                    }
                    if (vm.autoResolution.apply) {
                        validateAutoResolutionInputs();
                        return executeAutoResolution();
                    }
                })
                .then(loadContractAndLines)
                .then(function(result) {
                    vm.review = buildReview(result.lignes || []);
                    if (vm.review.hasOutstandingBalances) {
                        throw new Error('Le contrat n\'est pas à zéro après les ajustements automatiques.');
                    }
                    return Contrat.cloturer({
                        id: vm.idContrat,
                        closingContractReason: vm.selectedClosingContractReason ? {id: vm.selectedClosingContractReason.id} : null
                    }).$promise;
                })
                .then(function(result) {
                    $scope.$emit('wamasysApp:impactPenalitRemiseRegulUpdate', result);
                    $uibModalInstance.close(result);
                })
                .catch(handleFailure)
                .finally(function() {
                    vm.isSaving = false;
                });
        }

        function validateAutoResolutionInputs() {
            var hasFinancialAdjustments = vm.review.debtWaivers.length > 0 || vm.review.windfallGains.length > 0;
            var hasTransfers = vm.review.transfers.length > 0;
            if ((hasFinancialAdjustments && !vm.autoResolution.label) || ((hasFinancialAdjustments || hasTransfers) && !vm.autoResolution.commentaire)) {
                throw new Error('Le libellé et le commentaire sont obligatoires pour appliquer les ajustements automatiques.');
            }
        }

        function executeAutoResolution() {
            return runSequentially(vm.review.transfers, function(transfer) {
                return Billing.saveBalanceTransfer({
                    amount: transfer.amount,
                    commentaire: vm.autoResolution.commentaire,
                    ligneContrat: {id: transfer.sourceLine.id},
                    ligneContratCible: {id: transfer.targetLine.id}
                }).$promise;
            }).then(function() {
                return runSequentially(vm.review.debtWaivers, function(item) {
                    return createAdjustment(item.line.id, 'DEBT_WAIVER', item.amount);
                });
            }).then(function() {
                return runSequentially(vm.review.windfallGains, function(item) {
                    return createAdjustment(item.line.id, 'WINDFALL_GAIN', item.amount);
                });
            });
        }

        function createAdjustment(lineId, type, amount) {
            return ImpactPenalitRemiseRegul.save({
                ligneContrat: {id: lineId},
                type: type,
                montantTtc: amount,
                label: vm.autoResolution.label,
                commentaire: vm.autoResolution.commentaire
            }).$promise;
        }

        function runSequentially(items, callback) {
            var promise = $q.when();
            angular.forEach(items || [], function(item) {
                promise = promise.then(function() {
                    return callback(item);
                });
            });
            return promise;
        }

        function handleFailure(error) {
            vm.functionalError = resolveErrorMessage(error);
            return $q.reject(error);
        }

        function resolveErrorMessage(error) {
            if (!error) {
                return 'Une erreur est survenue.';
            }
            if (error.message) {
                return error.message;
            }
            if (error.data && error.data.message) {
                return error.data.message;
            }
            if (error.headers && angular.isFunction(error.headers)) {
                return error.headers('X-wamasysApp-error') || 'Une erreur est survenue.';
            }
            return 'Une erreur est survenue.';
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function canFinalize() {
            if (vm.step === 'input') {
                return true;
            }
            if (!vm.autoResolution.apply) {
                return !vm.review.hasOutstandingBalances;
            }
            return true;
        }

        function getPrimaryActionLabel() {
            if (vm.step === 'input') {
                return vm.isPreparing ? 'wamasysApp.contrat.closingAction.analyzing' : 'wamasysApp.contrat.closingAction.analyze';
            }
            return vm.isSaving ? 'wamasysApp.contrat.closingAction.closing' : 'wamasysApp.contrat.closingAction.confirm';
        }

        function roundAmount(value) {
            var numericValue = parseFloat(value || 0);
            return Math.round(numericValue * 100) / 100;
        }
    }
})();
